import { z } from "zod";

/** Money is integer paise everywhere. See AGENTS.md rule 2. */
export const paiseSchema = z.number().int().nonnegative();
export const signedPaiseSchema = z.number().int();

export { formatPaise } from "./format";

/**
 * Parses a rupee amount typed by a person ("120", "12.5", "1,200.75") into paise.
 * Returns null for anything that is not a plain non-negative amount with at most two decimals.
 */
export function parseRupees(input: string): number | null {
	const cleaned = input.trim().replace(/^₹\s*/, "").replaceAll(",", "");
	const match = /^(\d+)(?:\.(\d{0,2}))?$/.exec(cleaned);
	if (!match) return null;
	const whole = match[1] ?? "0";
	const fraction = (match[2] ?? "").padEnd(2, "0");
	const paise = Number(whole) * 100 + Number(fraction);
	return Number.isSafeInteger(paise) ? paise : null;
}
